{
  "version": 1,
  "asset_id": "df5f7d8d-2b78-44a2-a067-8342712d1bfd",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/df5f7d8d-2b78-44a2-a067-8342712d1bfd/process-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/df5f7d8d-2b78-44a2-a067-8342712d1bfd/process-640.avif",
  "original_filename": "process-640.avif",
  "size": 10964,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:38Z"
}
